"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuantityPicker = exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@commerce-ui/core2");
var _ButtonRaw = _interopRequireDefault(require("@commerce-ui/core2/ButtonRaw"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _SelectNative = _interopRequireDefault(require("@commerce-ui/core2/SelectNative"));
var _InputRaw = _interopRequireDefault(require("../InputRaw"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useLayoutEffect = typeof window === "object" ? _react.useLayoutEffect : _react.useEffect;
var defaults = {
  $buttonDecrease: {
    __type: _ButtonRaw["default"],
    __children: "-"
  },
  $buttonIncrease: {
    __type: _ButtonRaw["default"],
    __children: "+"
  },
  $root: function $root(_ref) {
    var focused = _ref.focused;
    return {
      position: "relative",
      display: "inline-flex",
      verticalAlign: "top",
      overflow: "hidden",
      flexDirection: "row"
    };
  },
  $input: function $input(_ref2) {
    (0, _objectDestructuringEmpty2["default"])(_ref2);
    return {
      __type: _InputRaw["default"],
      textAlign: "center"
    };
  },
  $select: function $select() {
    return {
      __type: _SelectNative["default"],
      __props: {
        allowEmpty: false
      }
    };
  }
};
var useQuantityPicker = function useQuantityPicker() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$step = props.step,
    step = _props$step === void 0 ? 1 : _props$step,
    defaultValue = props.defaultValue,
    _props$maxValue = props.maxValue,
    maxValue = _props$maxValue === void 0 ? 999 : _props$maxValue,
    _props$selectOptionsA = props.selectOptionsAmount,
    selectOptionsAmount = _props$selectOptionsA === void 0 ? global.__appConfig__.paginationQuantityPickerOptionsNumber - 1 : _props$selectOptionsA,
    onChange = props.onChange,
    _props$label = props.label,
    label = _props$label === void 0 ? "Quantity" : _props$label;
  var _useState = (0, _react.useState)(defaultValue || step),
    amount = _useState[0],
    setAmount = _useState[1];
  var _useState2 = (0, _react.useState)(defaultValue || step),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    inputFocusedAfterSelectingMore = _useState3[0],
    setInputFocusedAfterSelectingMore = _useState3[1];
  (0, _react.useEffect)(function () {
    setAmount(defaultValue);
    setInputValue(defaultValue);
  }, [defaultValue]);
  var inputRef = (0, _react.useRef)(null);
  var setValue = function setValue(number) {
    var newVal = number;
    if (isNaN(newVal)) {
      newVal = defaultValue;
    }
    newVal = Math.max(newVal, step);
    newVal = Math.min(newVal, maxValue);

    // Check if multiple of step
    var rest = newVal % step;
    if (rest != 0) {
      newVal = newVal - rest;
    }
    setAmount(newVal);
    setInputValue(newVal);
    if (newVal !== amount && onChange) {
      onChange(newVal);
    }
  };
  var isMin = amount === step;
  var isMax = amount === maxValue - maxValue % step;
  var buttonIncrementProps = {
    onClick: function onClick() {
      setValue(amount + step);
    },
    disabled: isMax
  };
  var buttonDecrementProps = {
    onClick: function onClick() {
      setValue(amount - step);
    },
    disabled: isMin
  };
  var submitInputValue = function submitInputValue() {
    setValue(parseInt(inputValue));
    setInputFocusedAfterSelectingMore(false);
  };
  var inputProps = {
    value: inputValue,
    onChange: function onChange(val) {
      setInputValue(val);
    },
    onBlur: function onBlur() {
      submitInputValue();
    },
    inputRef: inputRef
  };
  useLayoutEffect(function () {
    if (inputFocusedAfterSelectingMore) {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  });
  var selectOptions = [];
  var maxSelectAmount = selectOptionsAmount * step;
  var moreOption;
  if (maxValue <= global.__appConfig__.paginationQuantityPickerOptionsNumber) {
    for (var i = 1; i <= maxValue; i++) {
      selectOptions.push("".concat(i * step));
    }
    maxSelectAmount = maxValue;
  } else {
    for (var _i = 1; _i <= selectOptionsAmount; _i++) {
      selectOptions.push("".concat(_i * step));
    }
    moreOption = "".concat(selectOptionsAmount + step, "+");
    selectOptions.push(moreOption);
  }
  // select

  var exceedsSelectRange = amount > maxSelectAmount || inputFocusedAfterSelectingMore;
  var selectProps = {
    options: selectOptions,
    value: exceedsSelectRange ? moreOption : "".concat(amount),
    onChange: function onChange(val) {
      if (moreOption && val === moreOption) {
        setInputValue("");
        setInputFocusedAfterSelectingMore(true);
      } else {
        setValue(parseInt(val));
      }
    },
    label: label,
    placeholder: label
  };
  var ret = {
    // inputFocusedAfterSelectingMore,
    exceedsSelectRange: exceedsSelectRange,
    buttonIncrementProps: buttonIncrementProps,
    buttonDecrementProps: buttonDecrementProps,
    inputProps: inputProps,
    selectProps: selectProps,
    amount: amount,
    isMax: isMax,
    isMin: isMin,
    setAmount: setValue,
    reset: function reset() {
      setValue(-1);
    }
  };
  return _objectSpread(_objectSpread({}, ret), {}, {
    counterProps: {
      controller: ret
    }
  });
};
exports.useQuantityPicker = useQuantityPicker;
function QuantityPicker$(props) {
  var loading = props.loading;
  var _props$sx = props.sx,
    sx = _props$sx === void 0 ? {} : _props$sx;
  var controller;
  if (props.controller) {
    controller = props.controller;
  } else {
    controller = useQuantityPicker(props);
  }
  var _useState4 = (0, _react.useState)(false),
    focused = _useState4[0],
    setFocused = _useState4[1];
  var state = {
    focused: focused
  };
  sx = typeof sx === "function" ? sx(state) : sx;
  var _splitSx = (0, _core.splitSx)(sx),
    _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
    css = _splitSx2[0],
    customSx = _splitSx2[1];
  var rootCss = typeof customSx.$root === "function" ? customSx.$root(state) : customSx.$root;
  var onFocus = function onFocus(e) {
    // setFocused(true);
  };
  var onBlur = function onBlur(e) {
    setFocused(false);
  };
  var buttonDecrease;
  var buttonIncrease;
  if (customSx.$buttonDecrease !== null) {
    buttonDecrease = (0, _core.createElement)((0, _core.getElementSpec)(customSx.$buttonDecrease, defaults.$buttonDecrease, state, _objectSpread({
      onFocus: onFocus,
      onBlur: onBlur
    }, controller.buttonDecrementProps), "-"));
  }
  if (customSx.$buttonIncrease !== null) {
    buttonIncrease = (0, _core.createElement)((0, _core.getElementSpec)(customSx.$buttonIncrease, defaults.$buttonIncrease, state, _objectSpread({
      onFocus: onFocus,
      onBlur: onBlur
    }, controller.buttonIncrementProps), "+"));
  }
  var input = (0, _core.createElement)((0, _core.getElementSpec)(customSx.$input, defaults.$input, state), _objectSpread({
    type: "number",
    onFocus: onFocus,
    onBlur: onBlur,
    onEnter: controller.inputProps.onBlur
  }, controller.inputProps));
  var select = (0, _core.createElement)((0, _core.getElementSpec)(customSx.$select, defaults.$select, state), _objectSpread(_objectSpread({
    onFocus: onFocus,
    onBlur: onBlur
  }, controller.selectProps), {}, {
    disabled: loading
  }));
  return __jsx(_Box["default"], {
    sx: css
  }, __jsx(_Box["default"], {
    sx: [{
      display: "flex",
      flexDirection: "row"
    }, defaults.$root(state), rootCss]
  }, buttonDecrease, controller.exceedsSelectRange && input, !controller.exceedsSelectRange && select, buttonIncrease));
}
var _default = QuantityPicker$;
exports["default"] = _default;